import * as React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { ICustomTheme, ThemeContextV2 } from '../../../themeV2';

const Spinner: React.FC = () => {
  const defaultTheme = React.useContext(ThemeContextV2);

  return (
    <SpinnerCircle theme={defaultTheme}>
      <VisuallyHidden theme={defaultTheme}>Loading...</VisuallyHidden>
    </SpinnerCircle>
  );
};

const spin = keyframes`
  0% { transform: rotate(0deg); }
  30% { transform: rotate(90deg); }
  45% { transform: rotate(180deg); }
  65% { transform: rotate(270deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerCircle = styled.div<{
  theme: ICustomTheme;
}>`
  border-radius: 1000px;
  display: inline-block;
  font-size: 8px;
  height: 5em;
  width: 5em;
  position: relative;
  ${css`
    &:before,
    &:after {
      content: '';
      display: block;
      height: 2em;
      width: 2em;
      position: absolute;
      top: 1em;
      left: 1em;
      border-radius: 1000px;
      border-style: solid;
      border-width: 0.5em;
    }
    &:after {
      animation: 2s ${spin} linear infinite;
      @media (prefers-reduced-motion: no-preference) {
        animation: 1s ${spin} linear infinite;
      }
    }
  `}
  ${({ theme }: { theme: ICustomTheme }) => {
    return `
        background-color: ${theme.colors.blue900};
        &:before {
          border-color: ${theme.colors.white10};
        }
        &:after {
          border-color: ${theme.colors.yellow500} transparent transparent transparent;
        }
    `;
  }}
`;

const VisuallyHidden = styled.div`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

export default Spinner;
